import React from "react";
import "./Projects.css";
export default function ProjectCard(props) {
  return (
    <div className="card">
      {props.mobile ? (
          <img src={props.mock} className="mobile_style_img"  />
      ) : (
        <img src={props.mock} className="laptop_style_img" />
      )}
      <p className="projectTitle">{props.title}</p>
      <p className="projectDescription">{props.description}</p>
      <a className="demoButton" href={props.demo}>
        Demo
      </a>
      <a className="gitButton" href={props.gitLink}>
        Github
      </a>

      <div className="imgs">
        <img className="stackImg" src={props.img1} width={40} height={40} />
        <img className="stackImg" src={props.img2} width={40} height={40} />
        <img className="stackImg" src={props.img3} width={40} height={40} />
      </div>
    </div>
  );
}
